import { getReferees } from "@/services/referral.service";
import { useQuery } from "@tanstack/react-query";

export const useReferees = (
  referralId,
  enabled = true,
  params = { page: 0, size: 10, search: "" },
  options = {},
) => {
  const queryKey = [
    "referees",
    referralId,
    params.page,
    params.size,
    params.search,
  ];

  return useQuery({
    queryKey,
    queryFn: () =>
      getReferees({
        referralId,
        params,
      }),
    enabled: enabled && !!referralId,
    ...options,
  });
};
